var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightsGenieMaximized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#1A2531"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_27)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4299 61.4189C63.4299 61.4189 67.5011 62.7442 71.1492 60.8242C74.7973 58.9047 74.1895 51.7684 69.5782 51.2368C64.9668 50.7052 63.8832 63.3533 52.5401 67.1709C34.8692 73.1179 24.5954 44.1718 10.4794 50.7513C12.9104 47.626 15.6281 46.8632 18.394 47.1867C29.7016 48.5087 37.0163 61.4753 48.5637 61.0257C59.1712 60.6128 62.5293 51.1148 68.3536 49.2533C74.178 47.3911 80.0386 56.1877 76.391 61.6616C72.7429 67.1363 63.4299 61.4193 63.4299 61.4193V61.4189ZM46.4253 70.2147C42.673 70.2147 39.3838 72.0642 37.5453 74.8389C40.2012 74.1346 43.221 73.7357 46.4253 73.7357C49.6296 73.7357 52.6501 74.1346 55.3056 74.8389C53.468 72.0642 50.178 70.2147 46.4253 70.2147Z",
    fill: "url(#paint0_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4738 18.7539C56.3556 18.1312 56.0474 17.5221 55.5822 16.993C55.5043 16.9044 55.4186 16.8175 55.3305 16.7334C54.9333 16.3555 54.4512 16.0481 53.9378 15.8441C53.3058 15.5911 52.6181 15.488 51.9527 15.5478C51.2514 15.6117 50.6095 15.842 50.0957 16.2117C50.0153 16.2685 49.9869 16.3749 50.0265 16.4647C50.0376 16.4927 50.0528 16.5162 50.073 16.5348C50.1216 16.5809 50.1892 16.6015 50.2572 16.5879C50.8888 16.4692 51.4463 16.4284 51.9642 16.4659C52.5089 16.5026 53.0412 16.6258 53.5468 16.8257C54.0528 17.0284 54.5217 17.3062 54.9423 17.654C55.0408 17.7364 55.1397 17.8242 55.2357 17.9157C55.5311 18.1963 55.8125 18.5223 56.0976 18.9179C56.1055 18.9282 56.1145 18.9369 56.1236 18.9455C56.1829 19.002 56.2728 19.0205 56.3506 18.9871C56.4405 18.9476 56.4911 18.8512 56.4738 18.7535V18.7539ZM55.3824 17.7657C55.5019 17.879 55.6181 17.9969 55.7297 18.1217C55.6172 17.9977 55.5019 17.8794 55.3824 17.7657ZM55.7342 18.1263C55.8459 18.2499 55.953 18.3777 56.0577 18.5149C55.9534 18.381 55.8447 18.2511 55.7342 18.1263Z",
    fill: "url(#paint1_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6172 14.7854C55.7816 14.8897 55.9423 15.0046 56.0951 15.1241C55.9406 15.0034 55.7803 14.8913 55.6172 14.7854Z",
    fill: "url(#paint2_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3886 15.3721C56.293 15.2868 56.1962 15.2031 56.0952 15.124C56.1949 15.2036 56.2926 15.2868 56.3886 15.3721Z",
    fill: "url(#paint3_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7765 15.7457C56.685 15.6484 56.5886 15.5557 56.491 15.4646C56.5062 15.4786 56.5223 15.4922 56.5371 15.5062C56.6179 15.5829 56.6986 15.6628 56.7765 15.7452V15.7457Z",
    fill: "url(#paint4_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5372 15.5066C56.522 15.4921 56.5063 15.479 56.4911 15.465C56.5887 15.556 56.6852 15.6487 56.7766 15.746C56.6988 15.6632 56.618 15.5836 56.5372 15.507V15.5066ZM56.0951 15.1241C56.1961 15.2033 56.2929 15.2873 56.3885 15.3722C56.2925 15.2869 56.1948 15.2037 56.0951 15.1241ZM56.0951 15.1241C55.9419 15.0046 55.7816 14.8897 55.6172 14.7854C55.7803 14.8913 55.9406 15.003 56.0951 15.1241Z",
    fill: "url(#paint5_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2854 17.9548C58.0423 17.1034 57.573 16.2891 56.9286 15.6009C56.849 15.5169 56.7654 15.434 56.6818 15.3545C56.1016 14.8031 55.4008 14.3539 54.6505 14.0547C53.786 13.7111 52.8475 13.5578 51.9336 13.6105C50.9929 13.667 50.0931 13.9336 49.3304 14.3824C49.2398 14.438 49.2023 14.5505 49.2435 14.6478C49.2558 14.6741 49.2715 14.6976 49.2929 14.7178C49.3448 14.7668 49.4211 14.7875 49.4948 14.7677C50.3341 14.5278 51.159 14.4195 51.9443 14.4471C52.7535 14.4743 53.545 14.6383 54.2986 14.9403C55.0522 15.2424 55.7403 15.6648 56.3455 16.2022C56.4078 16.2586 56.4716 16.3163 56.5326 16.3744C57.0456 16.8624 57.5079 17.4496 57.9034 18.1189C57.9141 18.1349 57.9265 18.1526 57.9401 18.1654C57.9994 18.2219 58.0876 18.2388 58.1683 18.2058C58.2639 18.1634 58.3163 18.0566 58.2854 17.9548ZM56.095 15.1241C55.9405 15.0034 55.7802 14.8913 55.6171 14.7854C55.7815 14.8897 55.9422 15.0046 56.095 15.1241Z",
    fill: "url(#paint6_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0991 17.1628C59.7328 16.0811 59.1024 15.0611 58.2755 14.2114C58.1976 14.1314 58.1152 14.0502 58.0332 13.9724C57.2751 13.2516 56.3521 12.6611 55.3629 12.2683C54.2702 11.8323 53.0761 11.6275 51.9109 11.6766C50.728 11.7227 49.569 12.0301 48.5587 12.5622C48.4606 12.6137 48.419 12.7307 48.4631 12.8304C48.4742 12.8585 48.4911 12.8803 48.5109 12.8993C48.5657 12.9512 48.6465 12.973 48.7231 12.9475C49.7853 12.5861 50.8627 12.4105 51.9225 12.4266C52.9896 12.4414 54.044 12.6524 55.0497 13.0521C56.0481 13.4506 56.957 14.0218 57.751 14.7508L57.8544 14.8493C58.5882 15.547 59.2157 16.3815 59.7151 17.3289C59.7262 17.3507 59.7386 17.3685 59.755 17.3845C59.8144 17.441 59.9042 17.4595 59.9833 17.4249C60.0834 17.3808 60.1353 17.2679 60.0987 17.1632L60.0991 17.1628ZM58.2054 14.9058C58.2676 14.9688 58.3315 15.0298 58.3917 15.0945C58.3311 15.0298 58.2676 14.9684 58.2054 14.9058Z",
    fill: "url(#paint7_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8022 16.6427C61.7214 16.6761 61.6332 16.6588 61.5739 16.6023C61.5558 16.585 61.5401 16.5644 61.5294 16.5426C60.934 15.3211 60.1487 14.2443 59.199 13.341L59.1594 13.3035C58.6498 12.8275 58.1178 12.4142 57.5785 12.0758C57.0153 11.714 56.4174 11.4095 55.8023 11.1667C55.1929 10.9207 54.5489 10.7316 53.8859 10.603C53.2617 10.479 52.5914 10.4126 51.8975 10.4081C50.5675 10.4015 49.2391 10.6463 47.9499 11.1276C47.8704 11.1564 47.7868 11.1375 47.7303 11.0839C47.7089 11.0637 47.6936 11.0402 47.6809 11.0139C47.6368 10.9108 47.6809 10.7909 47.7826 10.7423C49.0389 10.1278 50.46 9.78292 51.8868 9.73924C52.5728 9.71616 53.2889 9.76767 54.0199 9.89501C54.7051 10.0158 55.3964 10.2123 56.0779 10.4806C56.7491 10.7505 57.3873 11.0851 57.9736 11.4717C58.4981 11.8195 58.9786 12.2011 59.4021 12.6037C59.4784 12.6763 59.5529 12.75 59.6246 12.8238C60.6341 13.8388 61.4256 15.0668 61.9151 16.3757C61.955 16.4803 61.906 16.599 61.803 16.6431L61.8022 16.6427Z",
    fill: "url(#paint8_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6219 15.8597C63.5411 15.896 63.4501 15.8791 63.3891 15.821C63.3722 15.8049 63.357 15.7847 63.3446 15.7612L63.0784 15.2181C63.0426 15.1493 63.0034 15.0805 62.9664 15.01C62.907 14.9016 62.8477 14.7899 62.7904 14.689C62.7517 14.6259 62.7158 14.5629 62.6771 14.5002C62.6104 14.3906 62.5436 14.2777 62.4773 14.1738C62.4357 14.1141 62.3953 14.0527 62.3553 13.9913C62.2828 13.8846 62.2115 13.7766 62.1349 13.6715C61.6742 13.0216 61.1477 12.4109 60.5659 11.855L60.5432 11.8331C59.3999 10.746 58.0208 9.86372 56.5561 9.27977C55.0806 8.6913 53.4622 8.3814 51.8722 8.38923C51.0683 8.39335 50.2649 8.47289 49.4845 8.6266C49.3559 8.65215 49.2303 8.68058 49.1046 8.70902C49.0337 8.7255 48.9612 8.74075 48.8978 8.756C48.7709 8.78896 48.6452 8.82317 48.52 8.85778C48.4491 8.87757 48.3799 8.8957 48.3164 8.91342C48.1986 8.94927 48.0791 8.98924 47.9612 9.02798C47.8863 9.0523 47.8109 9.0762 47.7433 9.09886L47.1677 9.31109C47.0898 9.34118 47.0058 9.31975 46.9497 9.26617C46.9283 9.24598 46.9114 9.22126 46.9003 9.19323C46.8562 9.08732 46.9065 8.96699 47.0107 8.92125L47.5752 8.67811C47.5797 8.67646 47.5838 8.67481 47.5871 8.67481L47.7668 8.60805C47.899 8.55695 48.0334 8.5075 48.1747 8.4597C48.2422 8.43703 48.3119 8.41602 48.3795 8.39376C48.5076 8.35338 48.6374 8.31134 48.7729 8.27219C48.8422 8.25406 48.9118 8.23593 48.981 8.2178C49.1108 8.18194 49.2422 8.14733 49.3753 8.11436C50.1969 7.92727 51.035 7.8226 51.8652 7.80323C52.6847 7.78262 53.5261 7.84897 54.3711 7.9998C55.1844 8.14733 55.9974 8.38058 56.7913 8.69212C57.5767 9.00944 58.3278 9.39928 59.0229 9.85424C59.6574 10.2721 60.2474 10.7374 60.774 11.2381C60.8424 11.3032 60.9095 11.3699 60.975 11.435C61.5663 12.0206 62.1028 12.6726 62.5696 13.3773C62.6437 13.4885 62.7134 13.6039 62.7863 13.7197C62.8234 13.7811 62.8609 13.8425 62.9025 13.9085C62.9709 14.0255 63.0347 14.1446 63.1003 14.2616C63.1345 14.323 63.1687 14.3877 63.2078 14.4565C63.2721 14.5843 63.3347 14.7104 63.3973 14.8365L63.4834 15.0112C63.4834 15.0141 63.4851 15.0186 63.488 15.0215L63.7294 15.5878C63.7735 15.6908 63.7278 15.8123 63.6235 15.861L63.6219 15.8597Z",
    fill: "url(#paint9_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3146 36.5519L52.0519 36.4827C54.5105 36.4827 57.2978 36.0582 58.9426 37.4523C60.5961 38.8551 60.7778 41.5387 59.133 43.1838C56.4927 45.8159 50.7796 42.4132 47.6202 41.1406L36.3151 36.5519H36.3146Z",
    fill: "url(#paint10_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.958 40.8811L40.5127 42.5694C39.2836 43.0458 38.2535 43.5651 37.0414 43.9895C31.2071 46.05 30.0382 38.4831 33.0249 37.1932C33.3883 37.037 33.9598 37.0284 34.6265 37.2884L43.958 40.8815V40.8811Z",
    fill: "url(#paint11_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7499 33.4872C49.1083 31.6344 49.8702 36.1539 51.6274 34.0497C51.2377 36.0929 47.3774 35.7467 45.7499 34.0324C44.1224 35.7467 40.2617 36.0929 39.872 34.0497C41.6293 36.1535 42.3911 31.634 45.7499 33.4872Z",
    fill: "url(#paint12_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9371 33.3919C34.1593 29.2619 37.5177 22.4569 40.3829 19.4181C42.5646 17.1149 45.1265 15.115 46.321 13.4006C50.5195 20.9503 47.1174 22.18 43.3087 24.3356C41.1707 25.5476 38.4007 29.158 40.9371 33.3919ZM47.7408 24.4572C49.3683 23.3751 51.1256 21.903 50.459 19.5739C55.9471 23.4093 57.9553 30.6733 50.7878 32.9852C53.5318 30.2493 50.398 24.7515 47.7408 24.4572Z",
    fill: "url(#paint13_linear_138_27)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9471 45.6776C55.9471 45.6776 50.3337 44.3828 45.958 41.9287C45.958 41.9287 39.1509 45.1221 35.8993 45.9285C35.8993 45.9285 35.034 54.6638 43.4327 56.9979C51.8314 59.332 57.7065 53.8561 62.104 48.2013C62.104 48.2013 58.5569 51.4127 55.4094 50.5749C52.262 49.7371 55.9471 45.6772 55.9471 45.6772V45.6776Z",
    fill: "url(#paint14_linear_138_27)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.1716 21.2454L36.1157 20.4797L29.1716 19.7141L28.406 12.77L27.6403 19.7141L20.6963 20.4797L27.6403 21.2454L28.406 28.1894L29.1716 21.2454Z",
    fill: "url(#paint15_linear_138_27)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9972 37.7296L22.3374 37.0305L15.9972 36.3314L15.2981 29.9912L14.599 36.3314L8.25879 37.0305L14.599 37.7296L15.2981 44.0698L15.9972 37.7296Z",
    fill: "url(#paint16_linear_138_27)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_138_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3261 70.9137L29.251 70.4809L25.3261 70.0482L24.8933 66.1233L24.4605 70.0482L20.5356 70.4809L24.4605 70.9137L24.8933 74.8386L25.3261 70.9137Z",
    fill: "url(#paint17_linear_138_27)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_138_27",
    x: 2.47949,
    y: 43.1182,
    width: 83.0405,
    height: 43.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_138_27",
    x: 42.0088,
    y: 11.5312,
    width: 22.4685,
    height: 19.4724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_138_27",
    x: 47.6172,
    y: 10.7854,
    width: 16.478,
    height: 16.3386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_138_27",
    x: 48.0952,
    y: 11.124,
    width: 16.2935,
    height: 16.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_138_27",
    x: 48.491,
    y: 11.4646,
    width: 16.2856,
    height: 16.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_138_27",
    x: 47.6172,
    y: 10.7854,
    width: 17.1594,
    height: 16.9607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_138_27",
    x: 41.2268,
    y: 9.60034,
    width: 25.0674,
    height: 20.6223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_138_27",
    x: 40.4456,
    y: 7.66943,
    width: 27.6648,
    height: 21.7729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_138_27",
    x: 39.6638,
    y: 5.73389,
    width: 30.2651,
    height: 22.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_138_27",
    x: 38.8843,
    y: 3.79956,
    width: 32.8618,
    height: 24.0793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_138_27",
    x: 28.3147,
    y: 32.4219,
    width: 39.9639,
    height: 23.7351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_138_27",
    x: 23.4377,
    y: 33.083,
    width: 28.5203,
    height: 23.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_138_27",
    x: 31.8721,
    y: 29.03,
    width: 27.7554,
    height: 18.4233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_138_27",
    x: 28.9709,
    y: 9.40063,
    width: 34.4382,
    height: 35.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_138_27",
    x: 27.874,
    y: 37.9287,
    width: 42.23,
    height: 31.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_138_27",
    x1: 7.54641,
    y1: 38.4554,
    x2: 19.7675,
    y2: 90.3957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_138_27",
    x1: 56.7602,
    y1: 14.4461,
    x2: 54.8416,
    y2: 20.7266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_138_27",
    x1: 56.116,
    y1: 14.6795,
    x2: 55.8837,
    y2: 15.2557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_138_27",
    x1: 56.4014,
    y1: 15.0465,
    x2: 56.2097,
    y2: 15.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_138_27",
    x1: 56.789,
    y1: 15.3768,
    x2: 56.552,
    y2: 15.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_138_27",
    x1: 56.8274,
    y1: 14.4852,
    x2: 56.0947,
    y2: 16.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_138_27",
    x1: 58.6909,
    y1: 12.1559,
    x2: 56.2454,
    y2: 20.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_138_27",
    x1: 60.6208,
    y1: 9.86539,
    x2: 57.6422,
    y2: 20.4422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_138_27",
    x1: 62.5531,
    y1: 7.56959,
    x2: 59.0378,
    y2: 20.2936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_138_27",
    x1: 64.4839,
    y1: 5.2748,
    x2: 60.4294,
    y2: 20.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_138_27",
    x1: 35.2662,
    y1: 34.0047,
    x2: 37.9839,
    y2: 48.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_138_27",
    x1: 30.8901,
    y1: 34.8143,
    x2: 35.1619,
    y2: 47.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_138_27",
    x1: 39.3577,
    y1: 32.2727,
    x2: 39.9122,
    y2: 36.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_138_27",
    x1: 36.1644,
    y1: 7.15336,
    x2: 53.8298,
    y2: 35.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_138_27",
    x1: 34.7264,
    y1: 37.0471,
    x2: 44.1162,
    y2: 64.7547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_138_27",
    x1: 36.7903,
    y1: 7.95146,
    x2: 23.6838,
    y2: 30.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_138_27",
    x1: 22.9533,
    y1: 25.5917,
    x2: 10.9865,
    y2: 46.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_138_27",
    x1: 29.6323,
    y1: 63.3998,
    x2: 22.2242,
    y2: 76.4183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.7674,
    height: 77.7674,
    fill: "white",
    transform: "translate(5.11621 5.11621)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_138_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0786,
    height: 14.0786,
    fill: "white",
    transform: "translate(8.25879 29.9912)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_138_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.71532,
    height: 8.71532,
    fill: "white",
    transform: "translate(20.5356 66.1233)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsGenieMaximized);
export default __webpack_public_path__ + "static/media/insights-genie-maximized.639e549a12641f5c94bca5435e79bba1.svg";
export { ForwardRef as ReactComponent };